import React, {useMemo} from "react";
import styles from "./OfferRow.module.css";
import {OfferType, SubtractionType} from "../../../../../../api/generated";
import {OfferTypeCard} from "../../../../offerTypeCard/OfferTypeCard";

interface OfferRowProps {
    isNew: boolean
    title: string
    description: string
    make: string
    model: string
    startDate: string
    endDate: string
    offerType: OfferType
    discount?: { value: number, type: SubtractionType }
    monthlyPayments?: number
}

export const OfferRow: React.FC<OfferRowProps> = ({
                                                      isNew,
                                                      title,
                                                      description,
                                                      make,
                                                      model,
                                                      startDate,
                                                      endDate,
                                                      offerType,
                                                      discount,
                                                      monthlyPayments,
                                                  }) => {

    const shortDescription = useMemo(() => {
        if (!description) return "";
        return description.length > 70 ? description.slice(0, 70) + "…" : description;
    }, [description]);

    const vehicleLabel = useMemo(() => {
        const safeMake = make === "*" ? "All Makes" : make;
        const safeModel = model === "*" ? "All Models" : model;
        return `${safeMake} ${safeModel}`;
    }, [make, model]);

    const discountLabel = useMemo(() => {
        if (!discount) return null;
        return discount.type === SubtractionType.Percentage
            ? `${discount.value}% off`
            : `£${discount.value} off`;
    }, [discount]);

    return (
        <div className={isNew ? styles.rowNew : styles.row}>
            <div className={styles.topRow}>
                <div className={styles.titleBlock}>
                    <span className={styles.title}>{title}</span>
                    {shortDescription && (
                        <span className={styles.description}>{shortDescription}</span>
                    )}
                </div>

                <div className={styles.tags}>
                    {typeof monthlyPayments === "number" && (
                        <span className={styles.priceTag}>£{monthlyPayments}/mo</span>
                    )}
                    {discountLabel && (
                        <span className={styles.discountTag}>{discountLabel}</span>
                    )}
                </div>
            </div>

            <div className={styles.bottomRow}>
                <span className={styles.vehicle}>{vehicleLabel}</span>
                <span className={styles.type}><OfferTypeCard offerType={offerType}/></span>
                <span className={styles.dates}>{startDate} – {endDate}</span>
            </div>
        </div>
    );
};
